import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setAuthToken } from '../api';
import './AdminSetupPage.css';

const AdminSetupPage = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        try {
            const { data } = await api.post('/api/user/register', { name, email, password });
            const { token } = data;

            // Save token for authentication
            localStorage.setItem('token', token);
            setAuthToken(token);

            setSuccess('Account created successfully! Redirecting to dashboard...');
            setTimeout(() => navigate('/dashboard'), 1500);
        } catch (err) {
            if (err.response && err.response.status === 403) {
                setError('Registration is closed. An account already exists.');
            } else {
                setError('Error creating account. Please try again.');
            }
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
            <div className="card p-4 shadow rounded-4" style={{ width: '100%', maxWidth: '400px' }}>
                <h2 className="text-center mb-4">Create First Account</h2>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Full Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            placeholder="Enter your full name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email address</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn w-100">Create Account</button>
                </form>

            </div>
        </div>
    );
};

export default AdminSetupPage;
